<template>
  <div
    class="hl-container vc-container"
    v-loading="uploadLoading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="row center">
      <el-date-picker
        v-model="Year"
        type="year"
        :editable="false"
        :clearable="false"
        value-format="yyyy"
        @change="loadTif"
        format="yyyy 年"
        placeholder="选择年份"
      >
      </el-date-picker>
      <el-button style="margin-left: 1rem" @click="computing" type="primary"
        >计算</el-button
      >
      <el-button style="margin-left: 1rem" @click="download" type="primary"
        >下载</el-button
      >
      <el-select
        style="margin-left: 1rem"
        v-if="haveTifOptions && Tif.tifPath"
        v-model="type"
        @change="loadTif"
        placeholder="请选择"
      >
        <el-option
          v-for="item in tifOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div v-if="Tif.value" style="margin-left: 1rem">
        <el-tag type="success"> 价值(亿元)</el-tag>
        <el-tag>{{ Number(Tif.value / 100000000).toFixed(6) }}</el-tag>
      </div>
    </div>
    <!-- <el-empty v-if="!Tif.tifPath" description="未查询到tif文件"></el-empty> -->
    <div class="map-view">
      <div class="map">
        <map-view v-if="Tif.tifPath" :map-id="mapId" ref="mapView" />
        <el-empty v-else description="请核算价值"></el-empty>
      </div>
      <div class="color">
        <div class="row">
          <el-tag
            @click="color_type = 'AREA'"
            style="cursor: pointer; margin-right: 10px"
            :type="color_type === 'AREA' ? '' : 'info'"
            >色带标识</el-tag
          >
          <el-tag
            @click="color_type = 'ARGB'"
            style="cursor: pointer; margin-right: 10px"
            :type="color_type === 'ARGB' ? '' : 'info'"
            >范围标识</el-tag
          >

          <el-button @click="showColor" type="success">预览</el-button>
          <el-button @click="saveColor" type="primary">保存</el-button>
        </div>
        <div class="row flex-center" style="margin-top: 10px">
          <el-tag style="margin-right: 1rem" type="success">色带</el-tag>
          <el-color-picker
            :disabled="color_type !== 'AREA'"
            v-model="ribbon_single.children[0].colors[0]"
            :predefine="predefineColors"
            color-format="rgb"
            show-alpha
          ></el-color-picker>
          <div
            :style="{
              background: `linear-gradient(90deg, ${ribbon_single.children[0].colors[0]}, ${ribbon_single.children[0].colors[1]})`,
            }"
            style="width: 500px; height: 35px"
          />
          <el-color-picker
            :disabled="color_type !== 'AREA'"
            v-model="ribbon_single.children[0].colors[1]"
            :predefine="predefineColors"
            color-format="rgb"
            show-alpha
          ></el-color-picker>
        </div>

        <div class="row" style="margin-top: 10px">
          <el-tag style="margin-right: 1rem" type="success">范围</el-tag>
          <div>
            <div class="row">
              <el-select
                @change="duanChange(0)"
                v-model="duan"
                :disabled="color_type !== 'ARGB'"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in 8"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-tag
                style="margin-left: 0.5rem; cursor: pointer"
                type="warning"
                @click="resize(0)"
                >相等间隔</el-tag
              >
              <el-tag
                style="margin-left: 0.5rem; cursor: pointer"
                type="warning"
                @click="resize(1)"
                >修改范围</el-tag
              >
            </div>
            <div
              v-if="color_type === 'ARGB'"
              style="margin-top: 5px; color: #a4a9b2"
            >
              切换间隔层数，范围默认修改为平均值
            </div>
            <div
              style="min-width: 500px; text-align: center; margin-top: 0.5rem"
            >
              <div class="row" style="margin-top: 1rem; font-size: 1.1rem">
                <span style="width: 48px">颜色</span>
                <span style="flex: 1">范围</span>
                <span style="flex: 1">标注</span>
              </div>
              <div
                class="row flex-center"
                style="margin-top: 0.2rem"
                v-for="(item, index) in ribbon_multi.children"
                :key="index"
              >
                <el-color-picker
                  :disabled="color_type !== 'ARGB'"
                  v-model="item.color"
                  color-format="rgb"
                  :predefine="predefineColors"
                  show-alpha
                ></el-color-picker>
                <span style="flex: 1">{{
                  `${baifenbi(item.range[0])}% ~ ${baifenbi(item.range[1])}%`
                }}</span>
                <span style="flex: 1">{{
                  `${item.range[0]} - ${item.range[1]}`
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="tif范围修改"
      :visible.sync="resizeVisiable"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div style="min-width: 500px; text-align: center">
        <div class="row" style="margin-top: 1rem; font-size: 1.1rem">
          <span style="flex: 1">颜色</span>
          <span style="flex: 1">范围</span>
          <span style="flex: 2.5">标注</span>
        </div>
        <div
          class="row flex-center"
          style="margin-top: 0.5rem"
          v-for="(item, index) in ribbon_multi_init.children"
          :key="index"
        >
          <el-color-picker
            style="flex: 1"
            v-model="item.color"
            color-format="rgb"
            :predefine="predefineColors"
            show-alpha
          ></el-color-picker>
          <span style="flex: 1">{{
            `${baifenbi(item.range[0])}% ~ ${baifenbi(item.range[1])}%`
          }}</span>
          <div style="flex: 2.5">
            <el-input-number
              size="mini"
              :max="1"
              :min="
                index === 0 ? 0 : ribbon_multi_init.children[index - 1].range[1]
              "
              :precision="3"
              :step="0.001"
              v-model="item.range[0]"
            />
            -
            <el-input-number
              size="mini"
              :max="
                index === ribbon_multi_init.children.length - 1
                  ? 1
                  : ribbon_multi_init.children[index + 1].range[0]
              "
              :min="0"
              :precision="3"
              :step="0.001"
              v-model="item.range[1]"
            />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resizeVisiable = false">取 消</el-button>
        <el-button @click="histogram" type="success">自动计算</el-button>
        <el-button type="primary" @click="resizeTrue">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MapView from "@/views/map/adjService/index.vue";
import his from "/src/components/map/map-histogram/histogram.js";
export default {
  name: "ValueCalculation",
  components: { MapView },
  props: {
    saveApi: {
      type: String,
      required: true,
      default: "",
    },
    loadApi: {
      type: String,
      required: true,
      default: "",
    },
    mathApi: {
      type: String,
      required: true,
      default: "",
    },
    mapId: {
      type: String,
      required: true,
      default: "w1",
    },
    haveTifOptions: {
      type: Boolean,
      required: false,
      default: false,
    },
    tifOptions: {
      type: Array,
      required: false,
      default: function () {
        return [{ label: "总值", value: 0 }];
      },
    },
  },
  data() {
    return {
      // 文件上传
      token: { token: "8H7949S2sC67eVZMEreMuYZKHpLR06hB" },
      uploadLoading: false,
      // 核算价值tif文件
      Tif: {},
      // 核算价值月份
      Year: "2020",
      // 核算价值类型
      type: 0,
      // 范围分段
      duan: 5,
      // 颜色值和预制颜色
      color_type: "AREA",
      predefineColors: [
        "#ff4500",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#00ced1",
        "#1e90ff",
        "#c71585",
        "rgba(255, 69, 0, 0.68)",
        "rgb(255, 120, 0)",
        "hsv(51, 100, 98)",
        "hsva(120, 40, 94, 0.5)",
        "hsl(181, 100%, 37%)",
        "hsla(209, 100%, 56%, 0.73)",
        "#c7158577",
      ],
      ribbon_single: {
        key: "ribbon_single",
        note: "单色带",
        children: [
          {
            range: [0, 1],
            value: [],
            colors: ["rgba(22, 249, 10, 1)", "rgba(249, 15, 7, 1)"],
            note: "色带",
          },
        ],
        defaultColor: "rgba(255,255,255,0)",
      },
      colors: [
        "rgba(255,69,0,1)",
        "rgba(255,140,0,1)",
        "rgba(255,215,0,1)",
        "rgba(144,238,144,1)",
        "rgba(0,206,209,1)",
        "rgba(30,144,255,1)",
        "rgba(199,21,133,1)",
        "rgba(255,36,36,1)",
      ],
      ribbon_multi: {
        key: "ribbon_multi",
        note: "多色带",
        children: [
          {
            range: [0, 0.2],
            value: [],
            color: "rgba(255,69,0,1)",
          },
          {
            range: [0.2, 0.4],
            value: [],
            color: "rgba(255,140,0,1)",
          },
          {
            range: [0.4, 0.6],
            value: [],
            color: "rgba(255,215,0,1)",
          },
          {
            range: [0.6, 0.8],
            value: [],
            color: "rgba(144,238,144,1)",
          },
          {
            range: [0.8, 1],
            value: [],
            color: "rgba(0,206,209,1)",
          },
        ],
        defaultColor: "rgba(255,255,255,0)",
      },
      // 范围颜色修改
      resizeVisiable: false,
      // 目前范围颜色对应预览，修改前，一般copy ribbon_multi
      ribbon_multi_init: {},
    };
  },
  created() {},
  async mounted() {
    this.uploadLoading = true;
    setTimeout(() => {
      this.uploadLoading = false;
      this.loadTif();
    }, 1000);
  },
  methods: {
    showColor() {
      const colors =
        this.color_type === "AREA"
          ? JSON.parse(JSON.stringify(this.ribbon_single))
          : JSON.parse(JSON.stringify(this.ribbon_multi));

      // 如果有tif复制刷新
      if (this.Tif && this.Tif.tifPath) {
        // 颜色复制
        this.Tif.colour = JSON.parse(JSON.stringify(colors));
        // map
        this.$store.dispatch("map/mapTiff/setSelected", {
          data: JSON.parse(JSON.stringify(this.Tif)),
        });
      } else {
        this.$message.warning("未查询到tif文件");
      }
      console.log(111, colors);
    },
    async saveColor() {
      // 如果有tif保存
      if (this.Tif && this.Tif.tifPath) {
        const colors =
          this.color_type === "AREA"
            ? JSON.parse(JSON.stringify(this.ribbon_single))
            : JSON.parse(JSON.stringify(this.ribbon_multi));

        const saveTif = await this.$store.dispatch(this.saveApi, {
          id: this.Tif.id,
          colour: JSON.stringify(colors),
        });
        if (saveTif.success) {
          this.$message.success("保存成功");

          // 颜色复制
          this.Tif.colour = colors;
          this.$store.dispatch("map/mapTiff/setSelected", {
            data: this.Tif,
          });
        } else {
          this.$message.warning(saveTif.message);
        }
      } else {
        this.$message.warning("未查询到tif文件");
      }
    },
    // 根据年份获取计算结果
    async loadTif() {
      const tifData = await this.$store.dispatch(this.loadApi, {
        date: this.Year,
        type: this.type,
      });
      if (tifData.success && tifData.result && tifData.result.length > 0) {
        this.Tif = tifData.result[0];
        // 拼接.ovr文件地址
        this.Tif.ovrPath = this.Tif.tifPath ? `${this.Tif.tifPath}.ovr` : "";
        // 接口返回有颜色，需要格式化一下
        if (this.Tif.colour) {
          this.Tif.colour = JSON.parse(this.Tif.colour);
          switch (this.Tif.colour.key) {
            case "ribbon_single":
              this.color_type = "AREA";
              this.ribbon_single = JSON.parse(JSON.stringify(this.Tif.colour));
              break;
            case "ribbon_multi":
              this.color_type = "ARGB";
              this.ribbon_multi = JSON.parse(JSON.stringify(this.Tif.colour));
              // 段数修改
              this.duan = this.ribbon_multi.children.length;
              break;
          }
        }
        console.log(111, this.Tif);
        // map
        this.$store.dispatch("map/mapTiff/setSelected", {
          data: this.Tif,
          visible: true,
        });
      } else {
        this.Tif = {
          value: 0,
        };
        this.$store.dispatch("map/mapTiff/setSelected", {
          visible: false,
        });
      }
    },
    // 根据年份计算tif
    async computing() {
      // 计算蒙版等待框
      this.uploadLoading = true;
      var loading = setTimeout(() => {
        this.uploadLoading = false;
      }, 60000);

      const colors =
        this.color_type === "AREA"
          ? JSON.parse(JSON.stringify(this.ribbon_single))
          : JSON.parse(JSON.stringify(this.ribbon_multi));

      const ct = await this.$store.dispatch(this.mathApi, {
        date: this.Year,
        colour: JSON.stringify(colors),
      });
      if (ct.success) {
        this.loadTif();
      } else {
        this.$message.error(ct.message);
      }

      // 计算蒙版关闭
      this.uploadLoading = false;
      clearTimeout(loading);
    },
    download() {
      if (this.Tif && this.Tif.tifPath) {
        window.open(this.Tif.tifPath);
      } else {
        this.$message.warning("未查询到tif文件");
      }
    },
    duanChange(type) {
      const d = 1 / this.duan;
      var c = [];
      var range = 0;
      for (let i = 0; i < this.duan; i++) {
        c.push({
          range: [Number(range.toFixed(3)), Number((range += d).toFixed(3))],
          value: [],
          color: this.colors[i],
        });
      }
      if (type === 1) {
        this.ribbon_multi_init.children = c;
        console.log(1111, this.ribbon_multi_init.children);
      } else {
        this.ribbon_multi.children = c;
      }
    },
    /**
     * 计算精度问题
     * */
    baifenbi(val) {
      return Math.round(val * 10000) / 100;
    },
    // 修改标注范围
    resize(type) {
      // 色带不做操作
      if (this.color_type === "AREA") return;

      this.ribbon_multi_init = JSON.parse(JSON.stringify(this.ribbon_multi));
      if (type === 0) {
        this.duanChange(1);
      }
      this.resizeVisiable = true;
    },
    resizeTrue() {
      this.ribbon_multi = JSON.parse(JSON.stringify(this.ribbon_multi_init));
      this.resizeVisiable = false;
    },
    async histogram() {
      if (this.Tif && this.Tif.tifPath) {
        const index = this.ribbon_multi.children.length + 1;
        let his1 = new his();
        const fenbu = await his1.quantileClassification(
          this.Tif.tifPath,
          0,
          index
        );
        this.ribbon_multi_init.children.map((item, index) => {
          item.range = [fenbu[index].toFixed(3), fenbu[index + 1].toFixed(3)];
        });
      } else {
        this.$message.warning("未获取到tif路径");
      }
    },
    // 修改标注范围dialog关闭前
    handleClose(done) {
      this.ribbon_multi_init = {};
      done();
    },
  },
};
</script>

<style lang="scss" scoped>
.vc-container {
  flex-direction: column;
  .row {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .center {
    align-items: center;
  }

  .flex-center {
    align-items: center;
  }

  .map-view {
    width: 100;
    flex: 1;
    display: flex;
    flex-direction: row;

    .map {
      width: 40%;
      height: 100%;
    }

    .color {
      flex: 1;
      margin-top: 1rem;
      height: 100%;

      ::v-deep .el-tag {
        font-size: 1rem;
        height: 40px;
        line-height: 40px;
        padding: 0 30px;
      }

      ::v-deep .el-color-picker {
        height: 50px;
        .el-color-picker__trigger {
          width: 48px;
          height: 48px;

          .el-color-picker__mask {
            width: 48px;
            height: 48px;
          }
          & > .el-color-picker__icon {
            font-size: 18px;
          }
        }
        .el-color-picker__mask {
          width: 48px;
          height: 48px;
        }
      }
    }
  }
}
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/ .el-input-number__increase {
  background: #25aff3;
  color: white;
}
/deep/ .el-input-number__decrease {
  background: #25aff3;
  color: white;
}
/deep/ .el-input-number__increase.is-disabled {
  background: #f5f7fa;
  color: #c0c4cc;
}
/deep/ .el-input-number__decrease.is-disabled {
  background: #f5f7fa;
  color: #c0c4cc;
}
</style>
